import { Theme } from '@mui/material';

export const orderStyles = (theme: Theme) => ({
	root: {
		display: 'flex',
		backgroundColor: '#000000',
		height: '100%',
		position: 'relative',
		flexDirection: 'column',
		overflow: 'hidden',
		pt: '30px',
	},
	loader: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: '#000000',
		height: '100%',
		position: 'relative',
	},
	content: {
		padding: { xs: '35px 8px', sm: '35px 16px', md: '35px 65px' },
		height: '100%',
		overflowY: 'auto',
		position: 'relative',
		display: 'flex',
		flexDirection: 'column',

		'&::-webkit-scrollbar': {
			width: '4px',
		},

		'&::-webkit-scrollbar-thumb': {
			borderRadius: '2px',
			backgroundColor: 'rgba(250, 250, 250, 0.7)',
		}
	},
	title: {
		fontFamily: 'Integral CF',
		fontSize: { xs: '22px', sm: '27px' },
		fontStyle: 'italic',
		fontWeight: 700,
		lineHeight: '32px',
		color: '#FFFFFF',
	},
	ticketsBox: {
		p: '24px',
		borderRadius: '8px',
		backgroundColor: '#13131380',
		border: '1px solid #00000080',
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
	},
	tickets: {
		display: 'flex',
		gap: '16px',
		width: { xs: '100%', md: 'fit-content', lg: '100%' },
		margin: 'auto',
		flexWrap: 'wrap',
		justifyContent: 'center',
	},
	description: {
		fontFamily: 'Montserrat',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '17px',
		color: '#FFFFFF',
	},
	membershipHeaderBox: {
		display: 'flex',
		flexDirection: { xs: 'column', sm: 'row' },
		alignItems: 'center',
		columnGap: '26px',
	},
	membershipTitle: {
		fontFamily: 'Integral CF, sans-serif',
		fontSize: '27px',
		fontWeight: '700',
		fontStyle: 'italic',
		lineHeight: '32px',
		color: 'white',
	},
	membershipDescription: {
		fontFamily: 'Montserrat',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '17px',
		color: '#FFFFFF',
	},
	membershipHostImageBox: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	membershipTitleBox: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
		py: '26px',
		px: { xs: '16px', sm: '0px' },
	},
	membershipBodyBox: {
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
		backgroundColor: '#13131380',
		borderRadius: '4px',
		p: '24px',
	},
	membershipBodyHeader: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
	},
	membershipHeaderTitle: {
		fontFamily: 'General Sans, sans-serif',
		fontWeight: 700,
		fontSize: '20px',
		lineHeight: '28px',
		color: '#FFFFFF',
	},
	membershipHeaderDescription: {
		fontFamily: 'General Sans, sans-serif',
		fontWeight: '400',
		fontSize: '15px',
		lineHeight: '21px',
		color: 'white',
	},
	eventBundleInfoRow: {
		display: 'flex',
		gap: '12px',
	},
	eventBundleInfoRowTitle: {
		fontFamily: 'Integral CF, sans-serif',
		fontWeight: 500,
		fontSize: '16px',
		color: '#FFFFFF',
	},
	appLink: {
		fontFamily: 'Montserrat',
		fontSize: '14px',
		fontWeight: 500,
		lineHeight: '17px',
		color: '#FFFFFF',
		flex: 1,

		'& a': {
			color: '#FFFFFF',
			textDecoration: 'underline',
		}
	},
	hostButton: {
		width: '154px',
		height: '46px',
		padding: '16px',
		borderRadius: '100px',
		fontFamily: 'Integral CF',
		fontSize: '12px',
		fontWeight: 500,
		lineHeight: '14px',
		textAlign: 'center',
		border: '1px solid #FFFFFF',
		color: '#FFFFFF',

		'&:hover': {
			color: '#000000',
			backgroundColor: '#FFFFFF',
		}
	},
	button: {
		width: '154px',
		fontFamily: 'Integral CF',
		fontSize: '12px',
		fontWeight: 500,
		lineHeight: '14px',
		borderRadius: '100px',
		backgroundColor: '#000000',
		color: '#FFFFFF',
		border: '1px solid #FFFFFF',
		p: { xs: '10px', md: '16px 22px' },
		minWidth: 'none',
		gap: '10px',

		"& >svg": {
			width: '24px',
			height: '24px',
		},

		'&:hover': {
			backgroundColor: '#FFFFFF',
			color: '#000000',
		},
	},
	secondaryButton: {
		backgroundColor: '#222327',
		border: 0,
		gap: '8px',

		"& >svg": {
			width: '16px',
			height: '16px',
		},

		'&:hover': {
			backgroundColor: 'rgba(250, 250, 250, 0.5)',

			'& .tooltip': {
				display: 'flex',
			},
		},
	},
	communityEventsTitle: {
		fontFamily: 'Integral CF',
		fontSize: '20px',
		fontWeight: 500,
		lineHeight: '24px',
		color: '#FFFFFF',

		"& >span": {
			textDecoration: 'underline',
		}
	},
	link: {
		fontFamily: 'General Sans',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '18px',
		color: '#FFFFFFCC',
		cursor: 'pointer',
		width: '50px',
		textDecoration: 'underline',
	},
	banner: {
		width: '661px',
		margin: '0 auto',
		borderRadius: '12px', 
		border: '1px solid rgba(42, 42, 42, 1)', 
		padding: '14px 29px',
		backgroundColor: 'rgba(26, 26, 26, 0.6)',
		backgroundRepeat: 'no-repeat',
		backgroundSize: 'contain',
		backgroundPosition: 'right center',

		'@media (max-width: 760px)': {
			width: '100%',
			backgroundColor: 'rgba(26, 26, 26, 1)',
			backgroundImage: 'none',
		}
	},
	bannerEffect: {
		position: 'absolute', 
		zIndex: 2, 
		top: 0, 
		left: 0, 
		width: '100%', 
		height: '100%', 
		backgroundSize: 'cover',
		borderRadius: '12px', 
		backgroundPosition: 'center top',
		backgroundRepeat: 'no-repeat',
	},
	bannerTitle: {
		fontFamily: 'Montserrat',
		fontSize: '18px',
		fontWeight: 700,
		lineHeight: '100%',
		color: 'rgba(255, 255, 255, 0.9)',
		marginBottom: '20px',
	},
	bannerContent: {
		display: 'flex',
		alignItems: 'center',
		gap: '12px',
		'& > svg': {
			color: '#FFFFFF',
		}
	},
	bannerContentText: {
		fontFamily: 'Montserrat',
		fontSize: '15px',
		fontWeight: 600,
		color: 'rgba(255, 255, 255, 0.9)',
	},
	downloadAppButton: {
		backgroundColor: '#FFFFFF',
		padding: '10px 24px',
		borderRadius: '100px',
		fontFamily: 'Montserrat',
		fontSize: '14px',
		fontWeight: 600,
		color: '#000000',
		lineHeight: '124%',
	}
});
